import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Only show navigation on homepage
  if (!isHomePage) {
    return null;
  }

  // Calculate scroll position with offset for fixed header
  const scrollToSection = (id) => {
    const element = document.getElementById(id.toLowerCase());
    if (element) {
      const headerOffset = 100; // Adjust this value to match your header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    } else {
      console.warn(`Section with ID '${id}' not found`);
      // Fallback to hash-based scrolling as a last resort
      window.location.hash = id.toLowerCase();
    }
  };

  return (
    <motion.nav
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-slate-900/95 backdrop-blur-md border-b border-slate-700/50' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center">
            <motion.div whileHover={{ scale: 1.02 }} className="flex items-center">
              <img 
                src="/images/Oxford_Holdings_Logo_web_transparant.png" 
                alt="Oxford Holdings" 
                className="h-16 w-auto max-w-[300px]"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <span className="text-2xl font-serif text-slate-100 tracking-wide hidden">
                Oxford Holdings<span className="text-amber-400 ml-1">•</span>
              </span>
            </motion.div>
          </Link>
          
          <div className="hidden md:flex space-x-8">
            {['Philosophy', 'Expertise', 'Approach', 'Contact'].map((item) => (
              <motion.button
                key={item}
                onClick={() => scrollToSection(item)}
                whileHover={{ y: -2 }}
                className="text-slate-300 hover:text-amber-400 transition-colors duration-300 text-sm tracking-wide bg-transparent border-none cursor-pointer"
                aria-label={`Scroll to ${item} section`}
              >
                {item}
              </motion.button>
            ))}
          </div>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navigation;